import type React from 'react';

interface AuthErrorBannerProps {
  error: string;
  onDismiss?: () => void;
  type?: 'warning' | 'error';
}

const AuthErrorBanner: React.FC<AuthErrorBannerProps> = ({ error, onDismiss, type = 'error' }) => {
  const errorId = `auth-error-${Date.now()}`;

  return (
    <div
      className={`authErrorBanner ${type}`}
      role="alert"
      aria-live="assertive"
      aria-labelledby={`${errorId}-banner-title`}
    >
      <div className="authErrorContent">
        <span className="authErrorIcon" aria-hidden="true">
          ⚠️
        </span>
        <span className="authErrorText">
          <span id={`${errorId}-banner-title`} className="sr-only">
            Authentication Error
          </span>
          <strong aria-hidden="true">Authentication Error:</strong> {error}
        </span>
      </div>

      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="authErrorDismissButton"
          aria-label="Dismiss authentication error message"
          title="Dismiss"
        >
          <span aria-hidden="true">×</span>
        </button>
      )}
    </div>
  );
};

export { AuthErrorBanner };
